import api from './api';

const cleanParams = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

const paymentService = {
  getPayrollUsers: async () => {
    const response = await api.get('/payment/users');
    return response.data;
  },

  getSalaryPreview: async (userId, month) => {
    const response = await api.get(`/payment/calculate/${userId}?${cleanParams({ month })}`);
    return response.data;
  },

  createPayment: async ({ userId, month, transactionId, uanNo, file }) => {
    const formData = new FormData();
    formData.append('userId', userId);
    formData.append('month', month);
    formData.append('transactionId', transactionId);
    if (uanNo) {
      formData.append('uanNo', uanNo);
    }
    formData.append('document', file);

    const response = await api.post('/payment/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getHistory: async (params = {}) => {
    const response = await api.get(`/payment/history?${cleanParams(params)}`);
    return response.data;
  },

  uploadSlip: async (paymentId, { transactionId, file }) => {
    const formData = new FormData();
    formData.append('transactionId', transactionId);
    formData.append('document', file);

    const response = await api.post(`/payment/upload-slip/${paymentId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  },

  regenerateSlip: async (paymentId) => {
    const response = await api.post(`/payment/regenerate-slip/${paymentId}`);
    return response.data;
  }
};

export default paymentService;
